<template>
  <div>
    <div class="category-field-wrapper mt-3">
      <draggable class="drag-category-editor mt-4" v-model="layoutArray" @start="drag=true" @end="drag=false, saveCategoryLayout()" >
        <div v-for="(fieldLayoutValues, index) in layoutArray" class="pt-3 pb-3 pl-2 pr-2 position-relative" :class="(index%2) ? 'odd' : 'even'" >
          <div class="d-inline-block align-middle move pl-3 pr-2 cursor-pointer"><i class="fa fa-arrows-v"></i></div>
          <div class="d-inline-block align-middle trash-can-category-editor pl-3 pr-2 cursor-pointer position-absolute" @click="activeIndex = index; modalTriggerConfirmDelete = true;"><trash class="svg-18"></trash></div>
          <category_builder_item :field_layout_values="fieldLayoutValues" index="index" :all_text_fields="all_text_fields" :used_text_fields="used_text_fields" :all_textarea_fields="all_textarea_fields" :used_textarea_fields="used_textarea_fields" :all_fileupload_fields="all_fileupload_fields" :used_fileupload_fields="used_fileupload_fields" :all_imageupload_fields="all_imageupload_fields" :used_imageupload_fields="used_imageupload_fields"></category_builder_item>
        </div>
      </draggable>
      <p v-if="layoutArray == ''">To build your category select a field type from the list below.</p>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-4 mb-3 pb-5">
      <a :href="action_url + '/edit'" class="btn btn-transparent pull-right mr-5 mt-2">Cancel</a>
      <button @click.prevent="saveCategoryLayout()" class="btn btn-bigger-font pull-right">Save</button>
    </div>

    <button class="btn btn-primary" @click.prevent="addTextField()" :disabled="(all_text_fields.length === used_text_fields.length)">Add Text Field</button>
    <button class="btn btn-primary" @click.prevent="addTextareaField()" :disabled="(all_textarea_fields.length === used_textarea_fields.length)">Add Textarea Field</button>
    <button class="btn btn-primary" @click.prevent="addFileUploadField()" :disabled="(all_fileupload_fields.length === used_fileupload_fields.length)">Add File Upload Field</button>
    <button class="btn btn-primary" @click.prevent="addImageUploadField()" :disabled="(all_imageupload_fields.length === used_imageupload_fields.length)">Add Image Upload Field</button>
    <button class="btn btn-primary" @click.prevent="addVideoUploadBlock()">Add Video Block</button>
    <button class="btn btn-primary" @click.prevent="addHeadlineField()">Add Headline</button>

    <modal v-if="modalTriggerConfirmDelete" @close="modalTriggerConfirmDelete = false">
      <h3 slot="header">Delete Field</h3>
      <div class="content" slot="body">
        <div>Are you sure you want to delete {{ layoutArray[activeIndex].field_label }} with machine name {{ layoutArray[activeIndex].machine_name }}? </div>
      </div>
      <div class="form-group-submit clearfix" slot="footer">
        <button class="btn btn-cancel btn-transparent pull-left" @click.prevent="modalTriggerConfirmDelete = false">Cancel</button>
        <a class="pull-right btn btn-primary" @click="deleteField()">Yes, delete field</a>
      </div>
    </modal>


  </div>
</template>

<script>
import modal from './Modal.vue';
import trash from "./icons/trash.vue";
import category_builder_item from '../components/CategoryBuilderItem';

export default {
  components: {modal, trash, category_builder_item},
  props: ['category_edit_layout', 'action_url', 'editable_text_fields', 'editable_textarea_fields', 'editable_fileupload_fields', 'editable_imageupload_fields'],
  data() {
    return {
      modalTriggerConfirmDelete: false,
      layoutArray: this.category_edit_layout,
      all_text_fields: this.editable_text_fields,
      used_text_fields: this.editableFieldsAvailable('text'),
      all_textarea_fields: this.editable_textarea_fields,
      used_textarea_fields: this.editableFieldsAvailable('textarea'),
      all_fileupload_fields: this.editable_fileupload_fields,
      all_imageupload_fields: this.editable_imageupload_fields,
      used_fileupload_fields: this.editableFieldsAvailable('file_upload'),
      used_imageupload_fields: this.editableFieldsAvailable('image_upload')
    }
  },
  methods: {
    editableFieldsAvailable: function(inputType) {
      // We run through this function to find fields already used.
      let app = this;
      let textFieldNames = [];
      app.category_edit_layout.forEach(function(field_details,i) {
        if(field_details.type === inputType) {
          textFieldNames.push(field_details.machine_name);
        }
      });

      return textFieldNames;
    },
    addTextField: function () {
      let app = this;
      app.layoutArray.push({
        'name': '',
        'field_label': '',
        'machine_name': '',
        'required': '',
        'type': 'text',
        'wrapping_class': 'col-6'
      })
    },
    addTextareaField: function () {
      let app = this;
      app.layoutArray.push({
        'field_label': '',
        'machine_name': '',
        'required': '',
        'type': 'textarea',
        'wrapping_class': 'col-6'
      })
    },
    addHeadlineField: function () {
      let app = this;
      app.layoutArray.push({
        'headline': '',
        'type': 'heading',
        'field_label': '',
        'description': ''
      })
    },
    addFileUploadField: function () {
      let app = this;
      app.layoutArray.push({
        'field_label': '',
        'machine_name': '',
        'required': '',
        'type': 'file_upload',
        'wrapping_class': 'col-6',
        'file_types': '.pdf',
        'description': '',
      })
    },
    addImageUploadField: function () {
      let app = this;
      app.layoutArray.push({
        'field_label': '',
        'machine_name': '',
        'required': '',
        'type': 'image_upload',
        'wrapping_class': 'col-6',
        'min_width': '',
        'max_width': '',
        'description': '',
      })
    },
    addVideoUploadBlock: function() {
      let app = this;
      app.layoutArray.push({
        'type': 'video_block',
        'closed_caption': ''
      })
    },
    saveCategoryLayout: function () {
      let app = this;
      window.axios(
          {
            method: 'PUT',
            url: app.action_url,
            params: {
              layout_edit: JSON.stringify(app.layoutArray)
            }
          }).then(function (response) {
        window.location.reload();
      }).catch(function (err) {
        let errorMessage = err.response.status + ' status error';
        app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
      });
    },
    deleteField: function() {
      let app = this;
      app.layoutArray.splice(app.activeIndex, 1);
      app.modalTriggerConfirmDelete = false;
      app.activeIndex = '';
      app.saveCategoryLayout();
    }
  }
}
</script>
